export default {
    name: "not-found",
    components: {},
    props: [],
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
